import React from 'react';

import {colors} from 'js-libs/sweetcommons/styles';
import styled from 'styled-components';

import type {ReactNode} from 'react';

const StyledIndentedDiv = styled.div`
  border-left: 3px solid ${colors.borderGray};
  margin-left: 5px;
  padding: 0.5rem;
  margin-top: 0.25rem;

  ul {
    padding-left: 1rem;
    margin: 0 0 0 0.25rem;

    li {
      padding: 0.25rem 0;
    }
  }
`;

interface Props {
  title: string;
  children: ReactNode;
}

export function IndentedFormGroup({title, children}: Props) {
  return (
    <div className="form-group">
      <div>{title}</div>
      <StyledIndentedDiv>{children}</StyledIndentedDiv>
    </div>
  );
}
